module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_6.a5fb95cf.png";